import { connect } from 'react-redux';
import { updateCompanionSlot } from '../../actions/';
import Companion from '../../components/companion/Companion';

const mapStateToProps = state => {
  return {
    companionWidth: state.companionWidth,
    companionHeight: state.companionHeight,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateState: data => {
      dispatch(updateCompanionSlot(data));
    },
  };
};

const CompanionRedux = connect(mapStateToProps, mapDispatchToProps)(Companion);

export default CompanionRedux;
